<template>
  <div class="cs-input" :class="[classes]">
    <label :for="inputId">
      <span>{{ displayName }}</span>
    </label>
    <input
      :id="inputId"
      ref="input"
      :type="type"
      :title="title"
      :placeholder="placeholder"
      :minlength="minLength"
      :maxlength="maxLength"
      :disabled="disabled"
      :value="value"
      @focus="handleFocus"
      @input="handleInput"
      @blur="handleBlur"
      @keydown.enter="handleSubmit"
    />
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  name: 'Input',
  props: {
    value: [Number, String],
    displayName: String,
    title: String,
    inputId: String,
    placeholder: String,
    type: {
      type: String,
      validator: inArray(['text', 'number', 'password', 'email', 'url']),
      default() {
        return 'text';
      },
    },
    required: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    minLength: {
      type: Number,
      default() {
        return 0;
      },
    },
    maxLength: {
      type: Number,
      default() {
        return 255;
      },
    },
    error: {
      type: Boolean,
      default() {
        return false;
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      internalValue: '',
      isFocused: false,
    };
  },
  computed: {
    classes() {
      return Object.assign(
        {
          invalid: this.error,
          focused: this.isFocused,
        }
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = val;
      },
    },
    internalValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleBlur() {
      this.isFocused = false;
      this.$emit('blur');
    },
    handleFocus() {
      this.isFocused = true;
      this.$emit('focus');
    },
    handleSubmit(e) {
      this.$emit('submit');

      if (e && e.target) {
        e.target.blur();
      }
    },
    handleInput(e) {
      this.internalValue = e.target.value.trim();
    },
  },
};
</script>

<style lang="sass" scoped>
  .cs-input
    position: relative
    display: flex
    flex-wrap: wrap
    padding: 10px 10px 8px
    background: rgba(40, 41, 61, 0.75)
    border-radius: 8px

    &.invalid
      box-shadow: 0 0 0 1px rgba(255, 81, 114, 0.5)

      label
        color: #FF5172

    &.focused
      background: #fff

      label
        color: rgba(0, 0, 0, 0.5)

      input
        color: #000

  input
    line-height: 40px
    font-size: 20px
    color: #fff

    &::placeholder
      color: $placeholder-color

  label
    width: 100%
    font-size: 14px
    line-height: 22px
    color: #7CB342
</style>
